<template>
  <AppLink
    class="flex items-center justify-center rounded-full p-1 hover:bg-gray-100"
    hide_underline
    :class="{ 'has-background-primary-light shadow-sm': route.name.startsWith(item.prefix) }"
    :data-test="item.data_test"
    :title="!mq.isMobile ? $t(item.title) : ''"
    :to="{ name: item.name, params: { project_id: current_project?.id, ...params } }"
    @click="toggleSidebar"
  >
    <div
      v-tooltip="{ value: hide_title ? $t(item.title) : '', showDelay: 150 }"
      :class="routeItemClasses"
    >
      <div class="flex shrink-0 items-center justify-center">
        <FontAwesomeIcon
          :class="route.name.startsWith(item.prefix) ? 'has-text-primary' : 'text-gray-500'"
          :icon="item.icon"
        />
      </div>
      <div
        v-if="!hide_title"
        :class="[
          route.name.startsWith(item.prefix)
            ? 'has-text-primary text-sm font-bold text-shadow-2xs'
            : 'text-sm font-medium text-gray-500',
        ]"
      >
        {{ $t(item.title) }}
      </div>
    </div>
  </AppLink>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useMqService } from '@/plugins/mq';

const store = useStore();

const route = useRoute();
const mq = useMqService();

const props = defineProps({
  item: { type: Object, required: true },
  params: { type: Object, default: () => ({}) },
  hide_title: { type: Boolean },
});

const current_project = computed(() => store.getters.current_project);
const emit = defineEmits(['update:modelValue']);

const toggleSidebar = () => {
  if (mq.isMobile) {
    emit('update:modelValue', false);
  }
};

const routeItemClasses = computed(() => {
  if (!props.hide_title) {
    return 'flex items-center gap-3 p-1 w-full';
  }
  return 'flex items-center justify-center size-8';
});
</script>
